<template>
  <div v-if="!isLogined" style="padding-top:300px;">
      <p>您还没有登录哦，请先登录</p>
      <van-button round @click="ShowLogin" type="info">点击登录</van-button>
  </div>
  <div v-else>
     <van-nav-bar title="收货地址" left-text="" left-arrow @click-left="onClickLeft()" />
     <van-cell-group inset>
      <van-field v-model="addrs.ContractName" label="姓名" readonly />
      <van-field v-model="addrs.ContractTel" label="电话" readonly />
      <van-field v-model="addrs.RegionFullDesc" label="地区" readonly />
      <van-field v-model="addrs.DetailAddr" label="详细地址" readonly />
    </van-cell-group>
     
  </div>
</template>

<script>
import { CellGroup, NavBar } from "vant";
import { Button, Field } from "vant";
export default {
  name: "ConvertAddrsDetail",
  data() {
    return {
      addrs: {
        ContractName:'',
        ContractTel:'',
        RegionFullDesc:'',
        DetailAddr:''
        },     
    };
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  methods: {
    ShowLogin(){
      this.$store.commit("showLogin");
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
    GetData(){
      var that = this;
      that.$http.get("Prizes/GetConvertAddr").then((res) => {
        if(res.data.Data.addrs!=null){
          that.addrs = res.data.Data.addrs;
        }
      });
    },
  },
  created() {
    this.GetData();
  },
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
  },
};
</script>

<style scoped>
    .van-panel {
    margin-top: 20px;
  }
</style>
